module.exports = __webpack_public_path__ + "static/media/caret-down.ccc81d33.svg";